import { usePageTitle } from "./hooks/usePageTitle";

function RelatedArticles() {
  usePageTitle('Related Articles')
  return (
    <div
      id="ts-relatedarticles-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-relatedarticles-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Related Articles
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Sample IMAGELog Headers
          </div>
          <div className="text-normal">
            TerraStation includes several sample IMAGELog headers for use with
            your log plots. These can be found in your userdata folder.
          </div>
          <a
            id="ts-relatedarticles-readmore"
            aria-label="Read more about Sample IMAGELog Headers"
            className="flex items-center p-2 mt-4 bg-light-main text-light-text-alt duration-200 hover:bg-light-main-hover rounded-sm cursor-pointer"
            href="/client-center/related-articles/sample-imagelog-headers"
          >
            <svg
              className="w-4 h-4 mr-2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M9 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Read More: Sample IMAGELog Headers
          </a>
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Ellipsoid Conversions in TerraStation
          </div>
          <div className="text-normal">
            TerraStation provides the capability of converting map data from one
            ellipsoid to another. The conversion involves a mathematical
            transform using relative offsets for the origin of the different
            ellipsoids used to represent the earth's surface.
          </div>
          <a
            id="ts-relatedarticles-readmore"
            aria-label="Read more about Ellipsoid Conversions in TerraStation"
            className="flex items-center p-2 mt-4 bg-light-main text-light-text-alt duration-200 hover:bg-light-main-hover rounded-sm cursor-pointer"
            href="/client-center/related-articles/ellipsoid-conversions"
          >
            <svg
              className="w-4 h-4 mr-2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M9 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Read More: Ellipsoid Conversions in TerraStation
          </a>
        </div>
        <div className="w-full flex flex-col text-light-text p-2 mt-4 text-left">
          <div className="text-lg border-b border-light-border mb-2">
            Kriging and TerraStation
          </div>
          <div className="text-normal">
            <span>
              Semivariogram modelling and 2D kriging are available in the
              TerraStation Mapping Module.
            </span>
            <div className="p-2"></div>
            <span>
              These options are located in Z Analysis of the Map Module. A
              variogram model must be built before performing 2D kriging. The
              display and building of variogram models are done in Variogram
              Displays in Z Analysis.
            </span>
          </div>
          <a
            id="ts-relatedarticles-readmore"
            aria-label="Read more about Sample IMAGELog Headers"
            className="flex items-center p-2 mt-4 bg-light-main text-light-text-alt duration-200 hover:bg-light-main-hover rounded-sm cursor-pointer"
            href="/client-center/related-articles/kriging-and-terrastation"
          >
            <svg
              className="w-4 h-4 mr-2"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M9 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Read More: Kriging and TerraStation
          </a>
        </div>
      </div>
    </div>
  );
}

export default RelatedArticles;
